import Seo from "@/components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy | Solar Black Belt"
        description="How assessment requests, photos and bills are collected, who receives them, and how to reach us about your data."
      />
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">PRIVACY NOTICE · POLICY 2026-10</span>
          <h1>Who sees your information, and why.</h1>
          <p className="lead">Last updated October 2026. This notice describes this website only — it is not Coastal Energy's own privacy policy.</p>
        </div>
      </section>
      <section style={{ paddingBottom: 30 }}>
        <div className="wrap prose" data-testid="privacy-content">
          <h2>Who operates this site</h2>
          <p>
            Commercial Solar ROI (commercialsolarroi.com) is <strong>Coastal Energy's</strong> dedicated commercial solar platform,
            providing project assessments, financial calculators, utility-bill reviews, and solar-plus-storage planning
            ("we", "us"). <strong>Lawrence Williams</strong> leads commercial and residential solar sales. The applicable project
            services are delivered by Coastal Energy.
          </p>
          <p>
            <strong>Coastal Energy offices</strong>
          </p>
          <ul data-testid="privacy-offices">
            <li><strong>Fort Myers:</strong> 12220 ITEC Haul Dr Ste 220, Fort Myers, FL 33913</li>
            <li><strong>Naples:</strong> 5660 Strand Ct A209, Naples, FL 34110</li>
            <li><strong>Miami:</strong> 7927 NW 67th St, Miami, FL 33166</li>
          </ul>

          <h2>What we collect</h2>
          <ul>
            <li><strong>Assessment requests:</strong> your name, email, phone, property address, electric-bill information, roof dimensions, priorities, storage interest and your answers to service questions — only what you enter.</li>
            <li><strong>Files you upload:</strong> utility bills (PDF/JPG/PNG) and roof or building photos (JPG/PNG/WebP), each under 15 MB.</li>
            <li><strong>Technical records:</strong> the page you submitted from, a request reference, and the time you gave consent. We also record anonymous funnel events (page paths, referrers and campaign parameters) that contain no personal information, bill details or file contents. IP addresses are processed only briefly for rate limiting and abuse prevention.</li>
          </ul>

          <h2>Who receives your information</h2>
          <p>
            When you request an assessment, your saved record is delivered to <strong>the commercial sales team</strong> — Lawrence
            Williams and any additional recipient addresses authorized in the site admin. Notifications are sent
            through a managed transactional email provider acting as a processor. Uploaded bills and photos are stored privately and are
            accessible only through authenticated admin access — never by public links, and never as email attachments.
          </p>
          <p>We do not sell your information. We do not use uploaded bills, photos or private project details for advertising, analytics,
            AI training or content syndication.</p>

          <h2>How long we keep it</h2>
          <p>
            Project records are kept while a project is active and afterwards only as long as needed for record-keeping, until you ask us
            to delete them. Rate-limiting data is short-lived. You can request deletion of your records at any time using the phone number
            below or the contact form.
          </p>

          <h2>Your choices</h2>
          <ul>
            <li>Contact consent is required to submit an assessment request. <strong>Marketing messages require a separate opt-in</strong> and never ride along automatically.</li>
            <li><strong>Marketing emails:</strong> every marketing email carries our Fort Myers office address and an unsubscribe link. You can stop all marketing emails at any time on our <a href="/unsubscribe" data-testid="privacy-unsubscribe">unsubscribe page</a> — the request is recorded and takes effect immediately.</li>
            <li><strong>Texts:</strong> reply <strong>STOP</strong> to any text we sent and we stop texting that number.</li>
            <li><strong>Calls:</strong> tell us on the line, or email <a href="mailto:info@sandsiftenvironmental.com">info@sandsiftenvironmental.com</a>, and we stop calling that number.</li>
            <li>You can ask what we hold about you, correct it, or have it deleted.</li>
            <li>Photos and bills stay in your browser until you submit a request.</li>
            <li>On the Learn page, progress is saved in your browser only if you turn that option on.</li>
          </ul>

          <h2>Cookies</h2>
          <p>
            The site uses essential functionality only by default. Admin sign-in uses strictly necessary session cookies. No advertising
            cookies are set by this site.
          </p>

          <h2>Security</h2>
          <p>
            Form submissions are validated server-side and rate limited. Uploads are checked for file type and signature, stored under
            random names, and image metadata is minimized. Email recipients are configured only by the authenticated site administrator —
            never chosen by visitors.
          </p>

          <h2>Contact</h2>
          <p>
            Questions or deletion requests: call <strong>310-881-5155</strong>, email
            <a href="mailto:info@sandsiftenvironmental.com">info@sandsiftenvironmental.com</a>, write to
            <strong>Coastal Energy, 12220 ITEC Haul Dr Ste 220, Fort Myers, FL 33913</strong>, or use the <a href="/contact">contact form</a>. If a
            processor list or operator legal name is updated, this notice will be re-dated and the policy version above will change.
          </p>
        </div>
      </section>
    </>
  );
}
